import moment from 'moment'
import "slick-carousel";

jQuery(document).ready(function ($) {


  // Tourdate Import
  $.ajax({
    url: `https://rest.bandsintown.com/artists/id_160939/events?app_id=45PRESS_dark_water`,
    // url: `https://rest.bandsintown.com/artists/id_1286461/events?app_id=45PRESS_dark_water`,
    method: 'GET',
    dataType: 'json',
    error: () => alert('Error fetching events!'),
    success: data => {
      const eventsContainer = $('#tour-dates');

      if (data.length) {
        // Generate HTML for each event and append to the events container
        const html = data.map(event => generateEventHtml(event)).join('');
        eventsContainer.html(html);

        // Hide the "toggle dates" button if fewer than 9 events are available
        if (data.length < 9) {
          $("#toggle-dates").hide();
        }
      } else {
        // Display message if no events are found
        eventsContainer.html('<span class="no-events">Check back soon for new shows!</span>');
      }
    }
  });

  // Helper function to generate HTML for each event
  function generateEventHtml(event) {
    const eventDate = moment(event.datetime).format('MMMM DD, YYYY');
    const venueName = event.venue.name;
    const venueRegion = event.venue.region !== null && event.venue.region !== '' ? event.venue.region : event.venue.country;
    const venueLocation = event.venue.city + ', ' + venueRegion;


    const offersHtml = event.offers.map(offer =>
      `<a href="${offer.url}" target="_blank" class="link btn">${offer.type}</a>`
    ).join('');

    return `
    <div class="event-group">
      <div class="event-date">${eventDate}</div>
      <div class="event-venue">${venueName}</div>
      <div class="event-location">${venueLocation}</div>
      <div class="event-links">${offersHtml}</div>
    </div>
  `;
  }



  // VIDEO CAROUSEL
  $(".video-carousel").slick({
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          vertical: false,
          verticalSwiping: false,
        }
      }
    ]
  });

  $(".video-slide").on("click", function (e) {
    e.preventDefault();
    let videoId = $(this).data("video-id");
    $("#video-player").attr("src", `https://www.youtube.com/embed/${videoId}?autoplay=1`);
  });


  // MOBILE MENU
  $('.mobile-menu-icon').on('click', function () {
    $("#nav-menu").toggleClass('active')
    $(".line").toggleClass('active')
  })

  $('.nav-item').on('click', function () {
    if ($('#nav-menu').hasClass('active')) {
      $("#nav-menu").toggleClass('active')
      $(".line").toggleClass('active')
    }
  })


  // SCROLLING
  function addSmoothScrolling() {
    $('a[href^="#"]').on('click', function (e) {
      e.preventDefault();

      var targetId = $(this).attr("href");
      $('html, body').animate({ scrollTop: $(targetId).offset().top }, 'slow');
    });
  }

  addSmoothScrolling(); 


  // VIDEO CAROUSEL LOGIC
  $('.video-slide').on('click', function (e) {
    e.preventDefault();

    const videoId = $(this).data('video-id');
    const videoTitle = $(this).find('img.thumbnail').attr('alt');

    // Update video player
    $('#video-player').attr('src', `https://www.youtube.com/embed/${videoId}`);

    // Update caption text
    $('#video-caption').text(videoTitle);
  });

});